//路由表
const routes = [
    {
        path: '/',
        component: () => import('@/App.vue'),
        name: 'App',
        children:[
            {
                path: '/',
                component: () => import('@/components/Head-Navigation'),
                name: 'Head-Navigation',
                children:[
                    {
                        path: '/',
                        component: () => import('@/components/home/Home-Page'),
                        name: 'Home-Page',

                    },
                    {
                        path: '/SaveAMarriage',
                        component: () => import('@/components/home/SaveAMarriage'),
                        name: 'SaveAMarriage',

                    },
                    {
                        path: '/MistressPersuadedToLeave',
                        component: () => import('@/components/home/MistressPersuadedToLeave'),
                        name: 'MistressPersuadedToLeave',

                    },
                    {
                        path: '/PremaritalCounseling',
                        component: () => import('@/components/home/PremaritalCounseling'),
                        name: 'PremaritalCounseling',

                    },
                    {
                        path: '/SuccessfulCase',
                        component: () => import('@/components/home/SuccessfulCase'),
                        name: 'SuccessfulCase',

                    },
                    {
                        path: '/ExpertTeam',
                        component: () => import('@/components/home/ExpertTeam'),
                        name: 'ExpertTeam',

                    },
                    {
                        path: '/AboutUs',
                        component: () => import('@/components/home/AboutUs'),
                        name: 'AboutUs',
                    },
                ]
            },
        ]
    },
]
export {routes}
